import styled, { css } from 'styled-components';

export const StylizedText = styled.p<{ textStyle: string }>`
  font-family: ${props => props.theme.fonts.circular} !important;
  text-align: center;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  font-size: 1.6rem !important;

  ${props =>
    props.textStyle === 'blueBold' &&
    css`
      color: ${props => props.theme.colors.capsuleBlue50} !important;
      font-weight: ${props => props.theme.fontWeights.semiBold} !important;
    `}

  ${props =>
    props.textStyle === 'grayNormal' &&
    css`
      color: ${props => props.theme.colors.capsuleGray50} !important;
      font-weight: ${props => props.theme.fontWeights.book} !important;
    `}
`;
